import { BehaviorValue, ReadingValue } from '@olympus/ngx-shared';

export function statisticsStateInitializer(): StatisticAppState {
  return {
    ReadingZoneMaximumValue: new BehaviorValue(),
    ReadingZoneMinimumValue: new BehaviorValue(),
    ReadingZoneMeanValue: new BehaviorValue(),
    ReadingZoneMedianValue: new BehaviorValue(),
    ReadingZoneStandardDeviation: new BehaviorValue(),
    ReadingZoneNumberOfElements: new BehaviorValue(),
    ReadingZoneNumberOfNoDataElements: new BehaviorValue(),
    ReadingZonePercentageOfNoDataElements: new BehaviorValue(),
    ReadingZoneNumberOfNoSynchroElements: new BehaviorValue(),
    ReadingZonePercentageOfNoSynchroElements: new BehaviorValue(),

    ReadingNoiseZoneMaximumValue: new BehaviorValue(),
    ReadingNoiseZoneMinimumValue: new BehaviorValue(),
    ReadingNoiseZoneMeanValue: new BehaviorValue(),
    ReadingNoiseZoneMedianValue: new BehaviorValue(),
    ReadingNoiseZoneStandardDeviation: new BehaviorValue(),
    ReadingNoiseZoneNumberOfElements: new BehaviorValue(),
    ReadingNoiseZoneNumberOfNoDataElements: new BehaviorValue(),
    ReadingNoiseZonePercentageOfNoDataElements: new BehaviorValue(),
    ReadingNoiseZoneNumberOfNoSynchroElements: new BehaviorValue(),
    ReadingNoiseZonePercentageOfNoSynchroElements: new BehaviorValue(),
  };
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface StatisticAppState {
  ReadingZoneMaximumValue: BehaviorValue<ReadingValue>;
  ReadingZoneMinimumValue: BehaviorValue<ReadingValue>;
  ReadingZoneMeanValue: BehaviorValue<ReadingValue>;
  ReadingZoneMedianValue: BehaviorValue<ReadingValue>;
  ReadingZoneStandardDeviation: BehaviorValue<ReadingValue>;
  ReadingZoneNumberOfElements: BehaviorValue<ReadingValue>;
  ReadingZoneNumberOfNoDataElements: BehaviorValue<ReadingValue>;
  ReadingZonePercentageOfNoDataElements: BehaviorValue<ReadingValue>;
  ReadingZoneNumberOfNoSynchroElements: BehaviorValue<ReadingValue>;
  ReadingZonePercentageOfNoSynchroElements: BehaviorValue<ReadingValue>;

  ReadingNoiseZoneMaximumValue: BehaviorValue<ReadingValue>;
  ReadingNoiseZoneMinimumValue: BehaviorValue<ReadingValue>;
  ReadingNoiseZoneMeanValue: BehaviorValue<ReadingValue>;
  ReadingNoiseZoneMedianValue: BehaviorValue<ReadingValue>;
  ReadingNoiseZoneStandardDeviation: BehaviorValue<ReadingValue>;
  ReadingNoiseZoneNumberOfElements: BehaviorValue<ReadingValue>;
  ReadingNoiseZoneNumberOfNoDataElements: BehaviorValue<ReadingValue>;
  ReadingNoiseZonePercentageOfNoDataElements: BehaviorValue<ReadingValue>;
  ReadingNoiseZoneNumberOfNoSynchroElements: BehaviorValue<ReadingValue>;
  ReadingNoiseZonePercentageOfNoSynchroElements: BehaviorValue<ReadingValue>;
}
/* eslint-enable @typescript-eslint/naming-convention */
